export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="flex-1 relative min-h-[320px] md:min-h-[420px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Cozy%20lifestyle%20scene%20with%20laptop%20on%20wooden%20desk%20surrounded%20by%20fashion%20magazines%20a%20tan%20leather%20bag%20and%20a%20warm%20drink%2C%20soft%20morning%20sunlight%20streaming%20through%20window%2C%20cream%20and%20terracotta%20tones%2C%20editorial%20quality%2C%20relaxed%20elegant%20composition%2C%20no%20text&width=1000&height=900&seq=cta-lifestyle-v2-2026&orientation=portrait"
          alt="acbuyspreadsheet lifestyle"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-50/40"></div>
        <div className="absolute bottom-8 left-8">
          <span className="text-xs tracking-widest uppercase text-foreground-500 font-medium">Get The</span>
          <h2 className="text-3xl md:text-5xl font-extrabold font-heading text-foreground-900 leading-tight">
            acbuy<br />spreadsheet
          </h2>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center py-12 px-8 bg-background-50 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 max-w-md leading-tight">
          Ready to Transform Your Buying Experience?
        </h2>
        <p className="mt-4 text-foreground-600 text-sm leading-relaxed max-w-md">
          Join thousands of savvy shoppers using <strong>acbuyspreadsheet</strong> to make smarter, faster, and more informed purchasing decisions every day.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          Visit kaspreadsheet.com
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}